import React from 'react'
import {ReactSVG} from 'react-svg'

export const Icons = ({path, className}) => {
  return (
    <ReactSVG src={path} className={className} wrapper='span'/>
  )
}